import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";

const RecipientActions = ({
  activeRecipientId,
  recipientId,
  handleDeleteRecipient,
  isHovered,
}) => {
  const showActions = activeRecipientId === recipientId || isHovered;
  return (
    <div className="recipient-actions">
      {showActions && (
        <>
          <button
            className="remove-recipient"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteRecipient();
            }}
          >
            <Icon name="trash-solid-b" />
          </button>

          <Image
            name="create-form/dragDots"
            ext="svg"
            className="drag-dots-icon"
          />
        </>
      )}
    </div>
  );
};

export default RecipientActions;
